'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGridLayout = require('react-grid-layout');

var _reactGridLayout2 = _interopRequireDefault(_reactGridLayout);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WidthProvider = _reactGridLayout2.default.WidthProvider,
    Responsive = _reactGridLayout2.default.Responsive;


function GridLayoutComponent(props) {
	var className = (0, _classnames2.default)((0, _defineProperty3.default)({
		'mk-grid-layout': true
	}, props.className, !!props.className));
	return _react2.default.createElement(_reactGridLayout2.default, (0, _extends3.default)({}, props, { className: className }));
}

function ResponsiveGridLayoutComponent(props) {
	var className = (0, _classnames2.default)((0, _defineProperty3.default)({
		'mk-grid-layout': true,
		'mk-grid-layout-responsive': true
	}, props.className, !!props.className));
	return _react2.default.createElement(Responsive, (0, _extends3.default)({}, props, { className: className }));
}

GridLayoutComponent.WidthProviderGridLayout = WidthProvider(GridLayoutComponent);

GridLayoutComponent.WidthProviderResponsive = WidthProvider(ResponsiveGridLayoutComponent);

exports.default = GridLayoutComponent;
module.exports = exports['default'];